import React, { useState } from 'react';
import axios from 'axios';
import './ask.css';
import Navbar from '../HomeComponents/Navbar';

const API_ENDPOINT = process.env.REACT_APP_OPENAI_API_ENDPOINT || 'http://localhost:8080';

export default function Ask() {
    const [prompt, setPrompt] = useState('');
    const [response, setResponse] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!prompt) {
            alert('Please enter a valid query');
            return;
        }
        setIsLoading(true)
        axios
            .post(`${API_ENDPOINT}/chat`, { prompt })
            .then((res) => {
                setResponse(res.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
                alert('An error occurred while processing your request.');
            });
    };

    return (
        <>
            <Navbar />
            <div className="main-container-ask">
                <h1 className="ask-title">Ask Your Doubts</h1>
                <p className="ask-para">
                    Keep clicking on submit for different answers and specify the number of words to get better answers.
                </p>
                <div className="main-form">
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder="Enter Your Doubt Here..."
                            value={prompt}
                            className="input-query"
                            onChange={(e) => setPrompt(e.target.value)}
                        />
                        <button className="button" style={{ width: '10vw', marginLeft: '1vw' }} type="submit">
                            <span className="button_lg">
                                <span className="button_sl"></span>
                                <span className="button_text">Submit</span>
                            </span>
                        </button>
                    </form>



                    <div className="response-container">
                        {isLoading && <div className="loading-spinner">
                            <div aria-label="Orange and tan hamster running in a metal wheel" role="img" class="wheel-and-hamster">
                                <div class="wheel"></div>
                                <div class="hamster">
                                    <div class="hamster__body">
                                        <div class="hamster__head">
                                            <div class="hamster__ear"></div>
                                            <div class="hamster__eye"></div>
                                            <div class="hamster__nose"></div>
                                        </div>
                                        <div class="hamster__limb hamster__limb--fr"></div>
                                        <div class="hamster__limb hamster__limb--fl"></div>
                                        <div class="hamster__limb hamster__limb--br"></div>
                                        <div class="hamster__limb hamster__limb--bl"></div>
                                        <div class="hamster__tail"></div>
                                    </div>
                                </div>
                                <div class="spoke"></div>
                            </div>
                        </div>}
                        <div>{response}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
